<template>
  <section class="flex-center" style="position: fixed;z-index: 99;width:100%;height:100%;left:0;top:0">
    <div style="background: #09898E;opacity: .5;" full></div>
    <div style="position: absolute;z-index:2;left:0;top:0" full class="flex-center">
      <slot></slot>
    </div>
  </section>
</template>
<script>


export default {
  mixins: [],
  name: "popup",
  computed: {
  },
  data() {
    return {
    };
  },
  methods: {
    
  },
  components: {
  }
};

</script>
<style scoped lang="scss">
</style>
